import { isUndefined } from '@sonar-software/sonar-ts-lib';
import { LoadingDots } from '@ui/general';
import { useOnMount } from '@hooks';

import React, { useState } from 'react';

const wrapperStart = (name: string) => `${name} (`;
const wrapperEnd = ')';

export interface PeriscopeMenuLabelProps {
	count: number | Promise<number> | undefined;
	name: React.ReactNode;
}

export const PeriscopeMenuLabel: React.FC<PeriscopeMenuLabelProps> = ({ count, name }) => {
	const [ countValue, setCountValue ] = useState(count);
	const [ isLoading, setIsLoading ] = useState(true);

	useOnMount(() => {
		Promise.resolve(count).then((value) => {
			setCountValue(value);
			setIsLoading(false);
		});
	});

	if (isUndefined(count)) {
		return name;
	}

	if (isLoading) {
		return (
			<>
				{ wrapperStart(name as string) }<LoadingDots />{ wrapperEnd }
			</>
		);
	}

	return `${name} (${countValue ?? 0})`;
};
